
// google统计代码
(function () {
  var t = document.createElement('script');
  t.src = '//www.googletagmanager.com/gtag/js?id=G-7ZF31S4H51';
  var o = document.getElementsByTagName('script')[0];
  o.parentNode.insertBefore(t, o);
  window.dataLayer = window.dataLayer || [];
  function gtag() { dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', 'G-7ZF31S4H51');
  window.gtag = gtag;
})();

// 听云
// https://report.tingyun.com/browser-web/#/browser/generalview
// import(/* webpackChunkName: "tingyun" */ '../lib/tingyun-rum.js');

// 阿里云监控
const BrowserLogger = require('alife-logger');

if (process.env.NODE_ENV === 'production') {
  const __bl = BrowserLogger.singleton({
    pid: 'hizpqrpejx@baa2458ae627484',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    useFmp: true,
    enableSPA: true
  });
}

import Vue from 'vue';
Vue.config.errorHandler = function (err, vm, info) {
  window.__bl && __bl.error(err);
  console.error(err);
};
